<template>
  <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                Payroll - Add/Edit Form
              <div class="card-header-actions">
                <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
              </div>
            </div>
            <b-row>
                <b-col lg="6">
                    <b-input-group >
                        <b-input-group-prepend><label>Employee</label></b-input-group-prepend>
                        <b-form-input v-model="model.crewinfo" readonly :state="!$v.model.crewkey.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCrewShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Marital Status</label></b-input-group-prepend>
                        <b-form-select v-model="model.kawin" :plain="true" :options="maritalStatus" disabled></b-form-select>
                      <b-form-checkbox  class="ml-1 mt-2" v-model="model.crewmale" value=1 unchecked-value=0 disabled>MALE</b-form-checkbox>
                        <b-input-group-prepend><span class="ml-4 pt-2">&nbsp; Dependent(Children+Wife)&nbsp; </span></b-input-group-prepend>    
                        <b-form-input v-model="model.tanggungan" type="number" disabled></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">person(s)</span></b-input-group-prepend>    
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>NPWP</label></b-input-group-prepend>
                      <b-form-input v-model="model.npwp" placeholder="Tax Identification Number" disabled></b-form-input>
                      <b-form-radio-group class="ml-2 mt-2" v-model="model.wni" name="radioWni" disabled>
                          <b-form-radio value="1">Indonesian</b-form-radio>
                          <b-form-radio value="0">Expatriate</b-form-radio>
                      </b-form-radio-group>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Bank Account#</label></b-input-group-prepend>
                        <b-form-input v-model="model.bankaccno" :state="!$v.model.bankaccno.$error"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Beneficiary</span></b-input-group-prepend>
                        <b-form-input v-model="model.beneficiary" :state="!$v.model.beneficiary.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Bank Name#</label></b-input-group-prepend>
                        <b-form-input v-model="model.bankname" :state="!$v.model.bankname.$error"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Job Title</label></b-input-group-prepend>
                      <b-form-input v-model="model.jabatan" placeholder="Job Title" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group >
                       <b-input-group-prepend><label>Grade/Golongan</label></b-input-group-prepend>
                        <!-- <b-form-select v-model="model.golonganid" :plain="true" :options="jobGroups" ></b-form-select> -->
                        <b-form-input v-model="model.golongan" disabled></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Department</span></b-input-group-prepend>
                        <b-form-input v-model="model.departemen" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Location</label></b-input-group-prepend>
                        <b-form-input v-model="model.location" disabled></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Project</span></b-input-group-prepend>
                        <b-form-input readonly v-model="model.projectname" ></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Working Time</label></b-input-group-prepend>
                        <b-form-input v-model="model.workingtime" type="number" disabled ></b-form-input>
                        <b-input-group-prepend><span class="pt-2">Hours</span></b-input-group-prepend>  
                          <b-form-checkbox class="ml-2 mt-2" disabled v-model="model.overtimeable" value=1 unchecked-value=0><b>Eligible for Over Time</b></b-form-checkbox>
                          <b-form-radio-group class="ml-1 mt-2" v-model="model.officer" name="radioOfficer" disabled>
                            <b-form-radio value="0">Shift/Scheduled</b-form-radio>
                            <b-form-radio value="1">Daily Worker</b-form-radio>
                          </b-form-radio-group>
                    </b-input-group>
                    <b-row>
                      <b-col lg="6">
                          <b-input-group>
                              <b-input-group-prepend><label style="width:140px !important;">Pajak Penghasilan</label></b-input-group-prepend>  
                              <b-form-checkbox class="mt-1" v-model="model.gajiNett" value=1 unchecked-value=0 disabled><b>Nett/Gross Up</b></b-form-checkbox>
                          </b-input-group>
                      </b-col>
                      <b-col lg="6" style="text-align:right;">
                          <b-form-radio-group v-model="model.terminate" name="radioTerminate" class="mt-2"  disabled>
                            <b-form-radio value="0">Active</b-form-radio>
                            <b-form-radio value="1">Terminate/Resign</b-form-radio>
                          </b-form-radio-group>
                      </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row >
                <b-col lg="4">
                    <b-input-group>
                    <b-input-group-prepend><label style="width:100px !important;">Payroll Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.payrolldate" type='date' :state="!$v.model.payrolldate.$error"></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row>

            <b-card no-body class="mb-1">
              <b-table
                  class="mb-0"
                  ref="tblDealLines"
                  style="font-size:smaller;" 
                  outlined striped hover small
                  :items="dealLines.items"
                  :fields="dealLines.fields"
                  :current-page="dealLines.page"
                  :per-page="dealLines.limit"
                    show-empty
                  >
                      <template v-slot:cell(index)="data">
                          {{data.index + 1}}
                      </template>
                      <template v-slot:cell(NilaiKomp)="data">
                      {{data.item.NilaiKomp|numFormat}}
                      </template>
                      <template v-slot:cell(TakeHome)="data">
                          <span v-if="(data.item.TakeHome==1)">Yes</span>
                      </template>
                      <template v-slot:cell(empty)="scope">
                        <h4>{{ scope.emptyText }}</h4>
                      </template>
                      <template v-slot:cell(emptyfiltered)="scope">
                        <h4>{{ scope.emptyFilteredText }}</h4>
                      </template>

                      <template v-slot:cell(action)="data">
                          <div class="text-center">
                          <a href="javascript:void(0)" @click="editDealLines(data.item,data.toggleDetails)">
                              <i class="fa fa-pencil"></i>
                          </a>
                          |
                          <a href="javascript:void(0)" class="text-danger" @click="delDealLines(data.index)">
                              <i class="fa fa-trash"></i>
                          </a>
                          </div>
                      </template>
                  <template v-slot:row-details="row">
                  <b-card class="row-details-form">
                      <b-row>
                        <b-col lg="7">
                            <b-input-group>
                                <b-input-group-prepend><label>Salary Item</label></b-input-group-prepend>
                                <b-form-input readonly v-model="dealLinesObj.NmKompGaji" :state="!$v.dealLinesObj.IdKompGaji.$error" style="width:60%;"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuSalaryitemShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                                <b-input-group-prepend><span class="pt-2 ml-2 mr-1">Seq.#</span></b-input-group-prepend>
                                <b-form-input v-model="dealLinesObj.nourut" type="number"></b-form-input>
                            </b-input-group>
                            <b-input-group>
                                <b-input-group-prepend><label>Note/Remark </label></b-input-group-prepend>
                                <b-form-input v-model="dealLinesObj.remark" ></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="5">
                            <b-input-group>
                                <b-input-group-prepend><label>Amount </label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span> </b-input-group-prepend>
                                <my-number v-model="dealLinesObj.NilaiKomp" :precision="2" :disabled="(dealLinesObj.userumus==1)" :state="!$v.dealLinesObj.NilaiKomp.$error" class="form-control text-right"></my-number>
                            </b-input-group>
                            <b-input-group>
                                <b-input-group-prepend><label>Jenis </label></b-input-group-prepend>
                                <b-form-input disabled v-model="dealLinesObj.JenisKomp" ></b-form-input>
                            </b-input-group>
                        </b-col>
                      </b-row>
                        <b-row class="justify-content-center">
                            <b-button v-if="saveEnabled" class="btn btn-info mr-1" @click="saveDealLines()">Update</b-button>
                            <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                        </b-row>

                  </b-card>
                  </template>                        
              </b-table>
            <b-row class="mt-2">
                <b-col cols="5">
                    <div  style="font-weight: bolder;display:inline">Take Home Pay : {{model.matauang}} {{dealLines.rekapfix | numFormat}}</div>
                    <b-button size="sm" class="ml-3" @click="addDealLines" >Add Salary Items</b-button>  
                </b-col>
                <b-col cols="7">
                    <b-row >
                      <b-col cols="6" style="text-align:center">
                        <div>
                          Showing {{(dealLines.page - 1) * dealLines.limit + 1}}
                          to <span v-if="((dealLines.page * dealLines.limit)>dealLines.total)">{{dealLines.total}}</span> <span v-else>{{dealLines.page * dealLines.limit}}</span>
                          of {{dealLines.total}} entries,   <span class="ml-3 mr-1">limit per page :</span> 
                          <select  v-model="dealLines.limit"  style="width:60px;">
                            <option>15</option>
                            <option>20</option>
                            <option>25</option>
                            <option>30</option>
                          </select>
                        </div>
                      </b-col>
                      <b-col cols="6">            
                        <b-pagination 
                          align="right"
                          :total-rows="dealLines.total"
                          :per-page="dealLines.limit"
                          v-model="dealLines.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                </b-col>
            </b-row>
            </b-card>    
            <b-row class="justify-content-center mb-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()"><i class="fa fa-save"></i> Save</button>
                <b-button class="btn btn-primary mr-1" @click.stop="close()" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
        </b-card>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew"></lku-crew>
        </b-modal>        
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Client/Project" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        
      <b-modal v-model="lkuSalaryitemShow" size="lg" :hide-footer="true" title="List of Salary Items" :centered="true" :lazy="true">
          <lku-salaryitem @click="onSelectLkuSalaryitem" ></lku-salaryitem>
      </b-modal>        
  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 120px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>
<script>
import moment from 'moment';
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import payroll from "../../apis/payroll";
import crud from "../../apis/crud";
import lkuCrew from "../lookup/lkuCrew";
import lkuCustomer from "../lookup/lkuCustomers";
import lkuSalaryitem from '../lookup/lkuSalaryitem';
import toastr from "mini-toastr";
toastr.init();

export default {   
  components:{myNumber,lkuCustomer,lkuCrew, lkuSalaryitem},
  mixins: [validationMixin],
  validations: {
        model: {
            crewkey: { required },
            contractkey: {required },
            bankaccno: { required },
            bankname: { required },
            beneficiary: { required },
            payrolldate: { required },
        },
        dealLinesObj: {
            IdKompGaji: { required },
            NilaiKomp : { required }
        },
  }, 
  data () {
    return {
        horizontal:true,
        saveEnabled:true,
        model:{crewkey: '',contractkey:'',
            workingtime: 8,
            overtimeable: 0,
            gajiNett: 1,
            bankaccno: '',
            bankname: '',
            beneficiary: '',
            kawin: '',
            tanggungan: '',
            crewmale: '',
            wni: '',
            officer:0,
             matauang:'IDR', },
        lkuCrewShow:false,
        lkuCustomerShow:false,
        lkuSalaryitemShow:false,
        currency:[{value:'IDR',text:'IDR'}],
        maritalStatus: [{value:0,text:'SINGLE'},{value:1,text:'MARRIED'}],
        departments:[],
        jobPositions:[],
        jobGroups:[],
        dealLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "KdKompGaji",
                    label: "Salary Item Code",
                    thStyle: "width:140px",
                },
                {
                    key: "NmKompGaji",
                    label: "Salary Item Name"
                },
                {
                    key: "NilaiKomp",
                    label: "Amount",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "JenisKomp",
                    label: "Jenis",
                    thStyle: "width:120px",
                },
                {
                    key: "TakeHome",
                    label: "Take Home",
                    thStyle: "width:40px",
                },
                {
                    key: "remark",
                    label: "Note/Remark",
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 15,
            total: 0,
        },
        dealLinesObj:{IdKompGaji:'', remark:'', NilaiKomp:''},
        timesheetFormulaVar:[],
        timesheetFormulaVal:[]
    }
  },
  computed: {
      invalidModel() {
        this.$v.model.$touch();
        return this.$v.model.$invalid;
      },
      invalidDealLines() {
        this.$v.dealLinesObj.$touch();
        return this.$v.dealLinesObj.$invalid;
      },
  },
  created: async function(){
      if (this.$route.params.payrollkey)  {
          toastr.info('Loading Crew Detail, please wait')
          try {
            // const data = await payroll.detail(this.$route.params);  
            const [t,a,b,c,data] = await Promise.all([crud.list({
                                                tablename:'timesheetvar',
                                                page: 1,
                                                limit: 15,
                                                total: 0,
                                                sortBy: 'tvarname',
                                                sortDesc: false
                                            }),payroll.department(),payroll.position(),payroll.group(),payroll.detail(this.$route.params)]) ;
            this.departments = a; 
            this.jobPositions = b; 
            this.jobGroups = c; 
            t.forEach((tv)=>{
                this.timesheetFormulaVar.push(tv.tvarname);
                this.timesheetFormulaVal.push(tv.tvarvalue);
            });

            for (var key in data.pyrlHeader) {
                this.model[key] = data.pyrlHeader[key];
            }
            this.model.payrolldate = this.model.payrolldate ? moment(this.model.payrolldate).format('YYYY-MM-DD') : '';

            // this.$forceUpdate();
            this.dealLines.items=data.pyrlDetail;
            this.dealLines.total=this.dealLines.items.length;
            this.dealLines.rekapfix = this.dealLines.items.reduce((a, b) => a + ((b.TakeHome==1) ? b.NilaiFix: 0), 0);

            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "Error Info",10000);                              
          }
      } else {
            const [t,a,b,c] = await Promise.all([crud.list({
                                                tablename:'timesheetvar',
                                                page: 1,
                                                limit: 15,
                                                total: 0,
                                                sortBy: 'tvarname',
                                                sortDesc: false
                                            }),payroll.department(),payroll.position(),payroll.group()
                        ]) ;
            this.departments = a; 
            this.jobPositions = b; 
            this.jobGroups = c; 
            t.forEach((tv)=>{
                this.timesheetFormulaVar.push(tv.tvarname);
                this.timesheetFormulaVal.push(tv.tvarvalue);
            });
      }

  },
  methods:{
    onSelectLkuCustomer: async function (_selected) {
        this.model.projectname = _selected.CustName.trim() + ' | ' + _selected.CustCode.trim();
        this.model.projectid = _selected.customer_id;
        this.lkuCustomerShow=false;
    },
    onSelectLkuCrew: async function (_selected) {
        this.model.crewinfo = _selected.crewname.trim() + ' | ' + _selected.crewnik.trim();
            for (var key in _selected) {
                this.model[key] = _selected[key];
            }        
        this.lkuCrewShow=false;
    },
    onSelectLkuSalaryitem: function(_selected){
        this.dealLinesObj.IdKompGaji =_selected.IdKompGaji;
        this.dealLinesObj.NmKompGaji =_selected.NmKompGaji;
        this.dealLinesObj.KdKompGaji =_selected.KdKompGaji;
        this.dealLinesObj.fixincome =(_selected.Upah) ? 0:1;
        this.dealLinesObj.JenisKomp = _selected.JenisKomp;
        this.dealLinesObj.TakeHome = _selected.TakeHome;
        this.dealLinesObj.rumus =_selected.rumus;

        this.lkuSalaryitemShow=false;
    },
    closeDealLines: function(){
        const opened= this.dealLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addDealLines : function () {
        this.closeDealLines();
        const obj={_showDetails:true,IdKompGaji:'', remark:'',  NilaiKomp:''};
        this.dealLines.selected = obj;
        this.dealLinesObj.NilaiKomp = 0;
        this.dealLinesObj.remark = '';
        this.dealLinesObj.IdKompGaji = '';
        this.dealLinesObj.nourut = this.dealLines.items.length+1;
        this.dealLines.items.push(obj);
        this.dealLines.total=this.dealLines.items.length;
    },
    editDealLines : function (obj,callback) {
        this.closeDealLines();
        this.dealLines.selected = obj;
        for (var key in this.dealLinesObj) {
            this.dealLinesObj[key] = '';
        }
        for (var key in obj) {
            this.dealLinesObj[key] = obj[key];
        }
        callback();
    },
    delDealLines: function (index) {
        if (index > -1) {
        this.dealLines.items.splice(index, 1);
        }
        this.dealLines.total=this.dealLines.items.length;
        this.dealLines.rekapfix = this.dealLines.items.reduce((a, b) => a + ((b.TakeHome==1) ? b.NilaiFix: 0), 0);
    },
    saveDealLines: async function (callback) {
        if (this.invalidDealLines) {
            console.log('validation : ', this.$v.dealLinesObj);
            console.log('model obj : ',this.dealLinesObj);
            toastr.error('Please fill the form correctly.', "Error Info");
       } else {
            try {
                    for (var key in this.dealLinesObj) {
                        this.dealLines.selected[key] = this.dealLinesObj[key];
                    }
                    this.dealLines.selected.NilaiFix = (this.dealLines.selected.JenisKomp === 'Penerimaan') ? this.dealLines.selected.NilaiKomp : (-1 * this.dealLines.selected.NilaiKomp);
                    this.dealLines.total=this.dealLines.items.length;
                    this.dealLines.rekapfix = this.dealLines.items.reduce((a, b) => a + ((b.TakeHome==1) ? b.NilaiFix: 0), 0);
                    this.dealLines.selected._showDetails=false;
                    if (callback) callback();
                    const sortedLines= this.dealLines.items.sort((a, b) => parseInt(a.nourut) - parseInt(b.nourut));   
                    this.dealLines.items= sortedLines;                

            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'Error Info',10000);
                } else {
                    toastr.error(JSON.stringify(error),'Error Info',10000);
                }
            }
        }
    },

    save: async function(){
        if (this.invalidModel) {
            console.log('validation  : ', this.$v.model);
            console.log('model : ',this.model);
            toastr.error('Please fill the form correctly.', "Error Info");
       } else {
            try {
              const data={};
              for (var key in this.model) {
                  data[key] = this.model[key];
              }
                data.payrolldate=moment(this.model.payrolldate).format('YYYY-MM-DD'); 
                data.takehomepay= parseFloat(this.dealLines.rekapfix || 0);
                    let newDealLines = this.dealLines.items.reduce((newArr, item, idx) => {
                        if ((item.IdKompGaji) && (item.NilaiKomp)) {
                            item.nourut = item.nourut || (idx+1); 
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);

              data.lines = newDealLines;
              await payroll.save(data);
              this.close();
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message, "Error Info",10000);
                } else {
                    toastr.error(JSON.stringify(error), "Error Info",10000);
                }              
            }
        }
    },
    
    close(){
        router.push({name: 'hrm.payroll'});
    },    
  }
}
</script>